var _path, _path2, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCuRadio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58346 2.65318C10.9376 1.64833 13.564 1.47629 16.029 2.16545C18.4941 2.85462 20.6505 4.36379 22.1422 6.44382C23.6338 8.52384 24.3716 11.0503 24.2337 13.6062C24.0957 16.1621 23.0903 18.5945 21.3835 20.502C19.6767 22.4094 17.3704 23.6777 14.8455 24.0976C12.3205 24.5175 9.72791 24.0638 7.49561 22.8114C5.26331 21.5591 3.52481 19.5829 2.56713 17.2092C1.60944 14.8355 1.48983 12.2062 2.22804 9.75541",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7769 6.36239C12.2619 5.86502 13.8709 5.88001 15.3464 6.40497C16.8219 6.92993 18.0788 7.93454 18.9159 9.25812C19.7531 10.5817 20.1223 12.1478 19.9643 13.7059C19.8064 15.2641 19.1305 16.7242 18.0447 17.8529C16.959 18.9816 15.5261 19.7135 13.9753 19.9317C12.4244 20.1499 10.8452 19.8418 9.4902 19.0565C8.13517 18.2713 7.08261 17.0543 6.50086 15.6002C5.91911 14.1462 5.84177 12.539 6.28122 11.0358L13 13L10.7769 6.36239Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.99526,
    y1: 1.36668,
    x2: 13.3667,
    y2: 13.0047,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuRadio);
export default __webpack_public_path__ + "static/media/CuRadio.99d436f0ea9cb15994b9dae7902c019c.svg";
export { ForwardRef as ReactComponent };